import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Field } from 'redux-form';

import SquareRadio from 'components/Input/SquareRadio';

const SquareOptions = ({
    wrapperClassName,
    className,
    name,
    options,
    small,
    children,
    formErrors,
}) => {
    const wrapperClasses = classnames({
        [wrapperClassName]: !!wrapperClassName,
    });

    const optionsClasses = classnames('radio-squares', className);

    return (
        <div className={wrapperClasses}>
            <div className={optionsClasses}>
                {options.map((e) => (
                    <Field
                        key={e.value}
                        component={SquareRadio}
                        name={name}
                        id={String(e.value)}
                        label={e.label}
                        small={small}
                    />
                ))}
            </div>
            {children}
            {formErrors && formErrors[name] && <p className="field-error">{formErrors[name]}</p>}
        </div>
    );
};

SquareOptions.displayName = 'SquareOptions';

SquareOptions.propTypes = {
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
    className: PropTypes.string,
    formErrors: PropTypes.shape({}),
    name: PropTypes.string,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
    ).isRequired,
    small: PropTypes.bool,
    wrapperClassName: PropTypes.string,
};

SquareOptions.defaultProps = {
    className: '',
    name: '',
    small: false,
};

/**
 * SquareOptions Functional Component.
 */
export default SquareOptions;
